import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import VipFormerLogo from '../assets/images/logo.png';
import { getProfileInitial, getVendorDisplayName } from '../utils/auth.js';

export default function VendorLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const displayName = getVendorDisplayName();
  const isOrdersPage = location.pathname === '/vendor/orders';
  const isHomePage = location.pathname === '/vendor/home';

  const signOut = () => {
    localStorage.clear();
    navigate('/signin');
    window.location.href = '/signin';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        px: { xs: 2, sm: 3 },
        py: 1.5,
        borderBottom: '1px solid #EAECF0',
        backgroundColor: '#fff',
        position: 'sticky',
        top: 0,
        zIndex: 1100,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, minWidth: 0 }}>
        <img
          src={VipFormerLogo}
          alt="VipFormer"
          style={{ height: isMobile ? 36 : 40, cursor: 'pointer' }}
          onClick={() => navigate('/vendor/home')}
        />
        <Typography
          sx={{
            fontWeight: 600,
            color: '#101828',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Seller Portal
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
        {!isMobile && (
          <Typography
            className="text-capitalize"
            sx={{ color: '#344054', fontSize: '0.9rem', mr: 1, maxWidth: 160 }}
            noWrap
          >
            {displayName}
          </Typography>
        )}
        <Button
          id="vendor-profile-button"
          aria-controls={menuOpen ? 'vendor-profile-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpen ? 'true' : undefined}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ minWidth: 'auto', p: 0.5 }}
        >
          <IconButton size="small" sx={{ p: 0 }}>
            <Typography
              className="default-img-border justify-center align-center display-flex primary-btn-text bg-input f-16 font-weight-700 text-capitalize candidate-profile"
              width={isMobile ? '36px' : '42px'}
              height={isMobile ? '36px' : '42px'}
              aria-label="Profile menu"
            >
              {getProfileInitial()}
            </Typography>
          </IconButton>
        </Button>
        <Menu
          id="vendor-profile-menu"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={() => setAnchorEl(null)}
          disableScrollLock
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {isMobile && (
            <MenuItem disabled sx={{ opacity: '1 !important', fontWeight: 600 }}>
              {displayName}
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              signOut();
            }}
            sx={{ color: '#B42318' }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}
